import { REPORT_PERMISSION_KEYS } from "@/utils/reportsAccess";
import { APPLICATION_AI_ASSISTANCE_PERMISSION_KEY } from "@/utils/applicationAiAssistanceAccess";

export const PERMISSION_KEYS = {
  USERS_VIEW: "users.view",
  USERS_CREATE: "users.create",
  USERS_EDIT: "users.edit",
  USERS_DELETE: "users.delete",
  USERS_APPROVE: "users.approve",
  USERS_ASSIGN_ROLE: "users.assign_role",

  ROLES_VIEW: "roles.view",
  ROLES_CREATE: "roles.create",
  ROLES_EDIT: "roles.edit",
  ROLES_DELETE: "roles.delete",
  ROLES_ASSIGN_PERMISSIONS: "roles.assign_permissions",
  ROLES_MANAGE_SIGNUP_APPROVAL: "roles.manage_signup_approval",

  PERMISSIONS_VIEW: "permissions.view",
  PERMISSIONS_CREATE: "permissions.create",
  PERMISSIONS_EDIT: "permissions.edit",
  PERMISSIONS_DELETE: "permissions.delete",

  APPLICATIONS_VIEW_OWN: "applications.view_own",
  APPLICATIONS_VIEW_ALL: "applications.view_all",
  APPLICATIONS_VIEW_WORKFLOW_PROGRESS: "applications.view_workflow_progress",
  APPLICATIONS_VIEW_LOCKED_IN_WORKFLOW: "applications.view_locked_in_workflow",
  APPLICATIONS_USE_AI_ASSISTANCE: APPLICATION_AI_ASSISTANCE_PERMISSION_KEY,
  APPLICATIONS_APPROVE: "applications.approve",
  APPLICATIONS_DENY: "applications.deny",
  APPLICATIONS_REQUEST_INFO: "applications.request_info",
  APPLICATIONS_REVIEW_EDIT_REQUESTS: "applications.review_edit_requests",
  APPLICATIONS_COMMENT: "applications.comment",
  APPLICATIONS_ASSIGN: "applications.assign",
  APPLICATIONS_EXPORT: "applications.export",
  APPLICATIONS_BULK_ACTIONS: "applications.bulk_actions",

  SERVICES_VIEW: "services.view",
  SERVICES_CREATE: "services.create",
  SERVICES_EDIT: "services.edit",
  SERVICES_DELETE: "services.delete",
  SERVICES_PUBLISH: "services.publish",
  SERVICES_PUBLISH_UNLISTED: "services.publish_unlisted",

  REPORTS_VIEW: REPORT_PERMISSION_KEYS.VIEW,
  REPORTS_ADVANCED: REPORT_PERMISSION_KEYS.ADVANCED,
  REPORTS_VIEW_ASSIGNED_APPLICATION_DATA:
    REPORT_PERMISSION_KEYS.ASSIGNED_APPLICATION_DATA,
  REPORTS_EXPORT: REPORT_PERMISSION_KEYS.EXPORT,
  REPORTS_CREATE: REPORT_PERMISSION_KEYS.CREATE,

  SETTINGS_VIEW: "settings.view",
  SETTINGS_EDIT: "settings.edit",
  SETTINGS_AUDIT_LOGS: "settings.audit_logs",

  PROFILE_VIEW: "profile.view",
  PROFILE_EDIT_BASIC: "profile.edit_basic_info",
  PROFILE_CHANGE_PASSWORD: "profile.change_password",

  DASHBOARD_VIEW: "dashboard.view",
  DASHBOARD_METRICS: "dashboard.metrics",
  DASHBOARD_VIEW_METRICS: "dashboard.view_metrics",
  DASHBOARD_VIEW_APPLICATIONS: "dashboard.view_applications",
  DASHBOARD_VIEW_PERFORMANCE: "dashboard.view_performance",

  FAQS_VIEW: "faqs.view",
  FAQS_CREATE: "faqs.create",
  FAQS_EDIT: "faqs.edit",
  FAQS_DELETE: "faqs.delete",

  SUPPORT_VIEW: "support.view",

  ANNOUNCEMENTS_VIEW: "announcements.view",
  ANNOUNCEMENTS_CREATE: "announcements.create",
  ANNOUNCEMENTS_EDIT: "announcements.edit",
  ANNOUNCEMENTS_DELETE: "announcements.delete",

  // CAPE / Sixth Form
  CAPE_VIEW: "cape.view",
  CAPE_SETTINGS_VIEW: "cape.settings.view",
  CAPE_REVIEW_EDIT_REQUESTS: "cape.edit_requests.review",
  CAPE_ASSIGN_SCHOOL: "cape.assign_school",
  CAPE_OVERRIDE_DECISION: "cape.override_decision",
  CAPE_REASSIGN_PLACEMENT: "cape.reassign_placement",
} as const;

export type PermissionKey =
  (typeof PERMISSION_KEYS)[keyof typeof PERMISSION_KEYS];
